'use client';

import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Check, X } from 'lucide-react';
import type { RefObject } from 'react';

import {
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from '@/components/ui/dialog';

interface FinishReadingReviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onLeaveReview: () => void;
  returnFocusRef: RefObject<HTMLElement | null>;
}

export function FinishReadingReviewDialog({
  open,
  onOpenChange,
  onLeaveReview,
  returnFocusRef,
}: FinishReadingReviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="z-[80]" />
        <DialogPrimitive.Content
          className="fixed left-1/2 top-1/2 z-[80] grid w-full max-w-[440px] -translate-x-1/2 -translate-y-1/2 gap-5 rounded-2xl border-0 bg-white p-6 text-[#1B1D22] shadow-xl outline-none"
          onCloseAutoFocus={(event) => {
            event.preventDefault();
            returnFocusRef.current?.focus();
          }}
        >
          <DialogHeader className="space-y-3 text-left">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#E9F9E5] text-[#3DAA2C]">
              <Check className="h-4 w-4" strokeWidth={2.5} />
            </div>
            <DialogTitle className="text-lg font-semibold tracking-normal text-[#1B1D22]">
              Вы дочитали последнюю главу
            </DialogTitle>
            <DialogDescription className="text-sm leading-5 text-[#6E7384]">
              Поделитесь впечатлениями о произведении с автором и читателями.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex-row justify-end gap-2 sm:space-x-0">
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="rounded-xl border border-[#E4E6ED] bg-white px-4 py-2.5 text-sm font-medium text-[#1B1D22] hover:bg-[#F7F8FA]"
            >
              Позже
            </button>
            <button
              type="button"
              onClick={onLeaveReview}
              className="rounded-xl bg-[#1B1D22] px-4 py-2.5 text-sm font-medium text-white hover:bg-[#2A2D34]"
            >
              Оставить отзыв
            </button>
          </DialogFooter>
          <DialogPrimitive.Close className="absolute right-3 top-3 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none">
            <X className="h-4 w-4" />
            <span className="sr-only">Закрыть</span>
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  );
}
